// extracted by mini-css-extract-plugin
export default {"no-selection":"PropertiesPanel_no-selection__aBG9K"};